import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {
  Box,
  Typography,
  Button,
  Container,
  Alert,
  AlertTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { requestID, baseUrl, config } from "../../common/utils";

import Papa from "papaparse";
import { useBusinessContext } from "../../context/business-context";

const BulkPosting = () => {


  const { selectedBusiness } = useBusinessContext();

  const [selectedFile, setSelectedFile] = useState(null);
  const [status, setStatus] = useState({ loading: false, error: false });
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [csvData, setCsvData] = useState<any[]>([]);


  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validExtensions = ["csv"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (validExtensions.includes(fileExtension)) {
        setSelectedFile(file);
        parseCSV(file)
      } else {
        alert("Invalid file type. Please upload a CSV or Excel file.");
        setSelectedFile(null);
      }
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file first.");
      return;
    }

    setStatus({ loading: true, error: false });

    console.log({ selectedFile });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("filePath", selectedFile);
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);

      const response = await axios.post(
        baseUrl() + "loanprocessors/uploadBulkPosting",
        formData,
        config
      );

      console.log(response);
      const { data } = response;



      // setSelectedFile(null);

      if (data.status === "false") {
        setStatus({ loading: false, error: true });
        setAlertMsg(response.data.message);
        onShowAlert();
      }

      setAlertMsg("File uploaded successfully");
      onShowAlert();
      setStatus({ loading: false, error: false });
    } catch (error) {
      console.error("Error uploading file:", error);
      alert(
        error.response?.data?.message || "An error occurred during upload."
      );
      setStatus({ loading: false, error: true });
    }
  };


    const parseCSV = (file: File) => {
      Papa.parse(file, {
        complete: (result) => {
          setCsvData(result.data);
        },
        header: true,
      });
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{"Bulk Posting"}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {showAlert && (
          <Alert
            severity={status.error ? "error" : "success"}
            sx={{
              mb: 3,
              borderRadius: 2,
              padding: "16px",
              boxShadow: 2,
            }}
          >
            <AlertTitle>{status.error ? "Error" : "Success"}</AlertTitle>
            {alertMsg?.toUpperCase()}
          </Alert>
        )}

        <Box
          textAlign="center"
          p={4}
          border={1}
          borderRadius={2}
          borderColor="grey.300"
          boxShadow={3}
          bgcolor="white"
          width="100%"
        >
          <Typography
            variant="h5"
            gutterBottom
            fontWeight="bold"
            sx={{ color: "#333" }}
          >
            Upload CSV
          </Typography>

          <input
            type="file"
            accept=".csv, .xlsx, .xls"
            onChange={handleFileChange}
            style={{
              marginBottom: "16px",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              width: "100%",
              boxSizing: "border-box",
              fontSize: "16px",
            }}
          />

          {csvData.length > 0 && (
            <>
              {/* Table with Pagination */}
              <Paper sx={{ width: "100%", overflow: "hidden", mt: 2 }}>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      {Object.keys(csvData[0]).map((key, index) => (
                        <TableCell key={index} sx={{ fontWeight: "bold" }}>
                          {key}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {csvData
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                          {Object.values(row).map((value, colIndex) => (
                            <TableCell key={colIndex}>
                              {value as string}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                {/* Pagination Component */}
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={csvData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>

              <Button
                variant="contained"
                color="primary"
                onClick={handleUpload}
                sx={{
                  mt: 2,
                  px: 4,
                  py: 1.5,
                  fontSize: "16px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#1976d2",
                  },
                }}
              >
                {status.loading ? "Loading..." : "Upload File"}
              </Button>
            </>
          )}

          {/* Link to download CSV template */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="body2" color="text.secondary">
              Need a template?{" "}
              <a
                href={"/csv/uploadusers.csv"}
                download="uploadusers.csv"
                style={{
                  textDecoration: "underline",
                  color: "#1976d2",
                }}
              >
                Download CSV Template
              </a>
            </Typography>
          </Box>
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default BulkPosting;
